import React, { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Icon, Input, Layout, Toast } from "@app/components";
import { createClass, getClassroom } from "@app/services";
import Select from "react-select";
import {
  ActionButton,
  ActionsWrapper,
  CommonLabel,
  DropdownWrapper,
  FlexWrapper,
  FormFlexWrapper,
  SelectCustomStyles,
  Error,
  DefaultMessage,
  EmptyContainer
} from "@app/components/commonStyles";
import { whiteColor } from "@app/styles";
import { emailPattern, gradesList, subjectOptions, useLocation, getValuesOnly, getLabelsOnly, numLim, allSubjectOptions } from "@app/utils";
import { faTrashAlt, faTruckLoading } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonContainer, GoogleSyncButton, StudentDetailWrapper } from "./educator-component";
import { PopUpContainer, PopUpSubTitle, PopUpText, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";
import { AuthContext } from "@app/providers";
import { useParams } from "react-router";

export default function CreateClassroom() {

  const [classroomCreated, setClassroomCreated] = React.useState(false);
  const { control, register, handleSubmit, errors, clear, reset, setValue, getValues }: any = useForm({});
  const { navigate } = useLocation();
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [showToast, setShowToast] = useState(false);
  const [clssroomId, setClassRoomId] = useState()
  const userToken = userInfo && userInfo.sessionToken;
  const [childSubject, setChildSubject] = useState<any>()
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const [classroomData, setClassroomData] = useState<any>([])
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const FirstName = userInfo && userInfo.userJson.firstName.concat(" ")
  const LastName = userInfo && userInfo.userJson.lastName
  const TeacherName = FirstName && FirstName.concat(LastName)
  const { id }: any = useParams()
  const [studentIdCount, setStudentIdCount] = useState<any>()
  const [editStudentErr, setEditStudentErr] = useState<boolean>()
  const [returnData, setReturnData] = useState<boolean>(true)
  const [noClassRoomErr, showNoClassRoomErr] = useState(false)
  const [spinner, setSpinner] = useState(false);
  const [classroomDetails, setclassroomDetails] = useState<any>([]);

  useEffect(() => {
    // let classes = JSON.parse(localStorage.getItem("classRooms")  || '')
    if (!userToken) {
      navigate("/sign-in")
    }
    if (id) {
      // getClassroomDetails()
    }

    if (id && localStorage.getItem("classroomDetails")) {
      const classromDetails = JSON.parse(localStorage.getItem("classroomDetails") || "")
      setStudentIdCount(classromDetails.studentIds.length)
      setclassroomDetails(classromDetails)
      if (classromDetails && id === classromDetails.classRoomId) {
        for (const [key, value] of Object.entries(classromDetails)) {
          if (key == "classGrade") {
            const classGrade = gradesList.find((grade: any) => grade.value === value)
            setValue("grade", classGrade)
          }
          if (key == "subject") {
            const classSubject = subjectOptions.find((subject: any) => subject.value === value)
            setValue("subject", classSubject)
          }
          else {
            setValue(key, value);
          }
        }
      } 
      else if(id){
        getClassroomDetails()
      }
      else{
        setReturnData(true)
        showNoClassRoomErr(true)
      }
    }
    else if(id){
      getClassroomDetails()
      localStorage.getItem("classroomDetails")
    }
    if (userInfo && userInfo.userJson.userType === "educator" && id) {
      // getClassroomDetails()
    }
    if (userToken && (userInfo.userJson.userType === "student" || userInfo.userJson.userType === "parent")) {
      navigate('/pagenotfound')
    }
  }, [])

  function onSubmit(data: any) {
    setEditStudentErr(false)
    if (!id) {
      setDisableButton(true)
    }
    setClassroomData(data)
    const params: any = {};

    if (id) {
      params["classRoomId"] = id
      if (data.studentsCount < studentIdCount) {
        setEditStudentErr(true)
        return false
      }
    }
    Object.assign(params, {
      sessionToken: userInfo.sessionToken,
      userId: userInfo.userJson.userId,
      classRoomName: data.classroomName ? data.classroomName : classroomDetails.classroomName,
      teacherName: data.teacherName ? data.teacherName : classroomDetails.teacherName,
      classRoomGrade: data.grade.value,
      classRoomSubject: data.subject.value,
      noOfStudents: data.studentsCount,
    });

    createClass(params)
      .then((resp: any) => {
        const response = resp;
        if (response._responseStatus === 1) {
          setClassRoomId(response.classRoomId)
          if (localStorage.getItem("classRooms")) {
          } else {
            getClassroomDetails()
          }
          setClassroomCreated(true);
          reset({
            classroomName: '',
            subject: '',
            grade: '',
            studentsCount: ''
          })
          let classes = JSON.parse(localStorage.getItem("classRooms") || '')
         
          if (!Array.isArray(classes)) {
            classes = [];
          }
          if (id) {
            let selectedClassRoom = classes.findIndex((classroom: any) => classroom.classRoomId == id);
            classes[selectedClassRoom] = response.classRoomJson;
          }
          else {
            classes.push(response.classRoomJson)
          }

          localStorage.setItem("classRooms", JSON.stringify(classes))
        } else {
          setToastMessage({
            type: "error",
            message: "Classroom hasn't created, Please try again.",
          });
          setShowToast(true);
        }
      })
  }

  const getClassroomDetails = () => {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo && userInfo.sessionToken,
      userId: userInfo && userInfo.userJson.userId,
    });
    if (id) {
      params["classRoomId"] = id
      params["studentsDataFlag"] = true
      setSpinner(true)
    }

    getClassroom(params)
      .then((resp: any) => {
        const response = resp;
        if (response._responseStatus === 1) {
          if (id) {
            setReturnData(true)
            setSpinner(false)
            setValue("classroomName", response.allClassroomsDocs[0].classRoomName)
            setValue("teacherName", response.allClassroomsDocs[0].teacherName || TeacherName)
            setValue('studentsCount', response.allClassroomsDocs[0].noOfStudents)
            setStudentIdCount(response.allClassroomsDocs[0].studentIds.length)
            const classGrade = gradesList.find((grade: any) => grade.value === response.allClassroomsDocs[0].classRoomGrade)
            setValue("grade", classGrade)
            const classSubject = subjectOptions.find((subject: any) => subject.value === response.allClassroomsDocs[0].classRoomSubject)
            setValue("subject", classSubject)
          }
        }
        else {
          setReturnData(true)
          if (id) {
            setSpinner(false)
            showNoClassRoomErr(true)
            setDisableButton(true)
          }
        }
      })
  }


  function onChange(data: any) {
    // if (data.target.value !== "") {
    // setDisableButton(true);
    // }

  }

  function createClassroom() {
    setClassroomCreated(true);
  }
  function classRoomSuccess() {
    setClassroomCreated(false)
    setDisableButton(false)
    if (id) {
      navigate('/classrooms')
    }
  }

  function handleDisable(){
    if(!returnData && id){
      return true;
    }else{
      if(classroomDetails && classroomDetails.googleClassroomId){
        return true;
      }else{
        return false;
      }
    }
  }

  return (
    <>
      <Layout>

        <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
          <h3 className="primary-header text-center mb-3">
            {id ? "Edit Classroom" : "Create a Classroom"}
          </h3>
          {spinner && id &&
            <EmptyContainer className="without-pos1">
              <Icon name="loader" />
              <DefaultMessage>Loading, please wait...</DefaultMessage>
            </EmptyContainer>
          }

          {!spinner && returnData && noClassRoomErr ? <EmptyContainer className="without-pos1 mb-2 text-center">
            <Error>Requested classroom does not exists.</Error>
          </EmptyContainer> : ''}

          {returnData && !spinner && !noClassRoomErr && <>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  label="Classroom Name"
                  placeholder="Enter Classroom Name"
                  name="classroomName"
                  defaultValue={''}
                  disable={handleDisable()}
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  autoFocus={true}
                  error={errors.classroomName && "Please enter Classroom Name"}
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  label="Teacher Name"
                  placeholder={''}
                  defaultValue={TeacherName}
                  disable={handleDisable()}
                  name="teacherName"
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={errors.teacherName && "Please enter Teacher Name"}
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <CommonLabel className="label-color">Grade</CommonLabel>
                <DropdownWrapper>
                  <Controller
                    as={<Select isSearchable={false} />}
                    value="value"
                    name="grade"
                    options={gradesList}
                    placeholder="Select Grade"
                    control={control}
                    rules={{ required: true }}
                    styles={SelectCustomStyles}
                    defaultValue={""}
                    menuPosition={"fixed"}
                  />
                  {errors.grade && <Error>Please select Grade</Error>}
                </DropdownWrapper>
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
              <CommonLabel className="label-color">Subject</CommonLabel>
              <DropdownWrapper>
                  <Controller
                    as={<Select isSearchable={false} />}
                    value="value"
                    name="subject"
                    options={subjectOptions}
                    placeholder="Select Subject"
                    control={control}
                    rules={{ required: true }}
                    styles={SelectCustomStyles}
                    defaultValue={""}
                    menuPosition={"fixed"}
                  />
                  {errors.subject && <Error>Please select subject</Error>}
                </DropdownWrapper>

              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <Input
                  label="No. of Students"
                  placeholder="Enter No. of Students"
                  type="number"
                  maxLength={2}
                  max={1}
                  min={40}
                  defaultValue={""}
                  name="studentsCount"
                  register={register({
                    required: true,
                    pattern: numLim,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  // error={(
                  //   (errors.studentsCount && "Please enter no. of students") ||
                  //   (errors.studentsCount && errors.studentsCount.type === "pattern") && "gan"
                  // )}
                  error={
                    (errors.studentsCount &&
                      errors.studentsCount.type === "required" &&
                      "Please enter no. of students") ||
                    (errors.studentsCount &&
                      errors.studentsCount.type === "pattern" &&
                      "Max no.of students are 40") ||
                    (editStudentErr &&
                      <p>Max no.of students count does not allow less than existing students count ({studentIdCount}) </p>)

                    //   ||
                    // (errors.studentsCount &&
                    //   errors.studentsCount.type === "pattern" &&
                    //   "Exceeds max no.of Students 20")
                  }

                />
              </div>
            </FormFlexWrapper>
            {userInfo && userInfo.userJson.googleAccountId && <GoogleSyncButton onClick={() => navigate('/google-classrooms')} className="anchor-tag">
                  + Sync Google Classroom
            </GoogleSyncButton>}
            {userInfo && userInfo.userJson.cleverAccountId && <GoogleSyncButton onClick={() => navigate('/clever-classrooms')} className="anchor-tag">
                  + Sync Clever Classroom
            </GoogleSyncButton>}
            {/* <div className="mb-2 text-center"><Error>{noClassRoomErr}</Error></div> */}

            <ButtonContainer>
              <Button
                type="submit"
                variant="newsecondary"
                size="large"
                width="100%"
                disabled={disableButton}
              // onClick={() => createClassroom()}
              >
                Submit
            </Button>
            </ButtonContainer>
          </>}
          <Button
            type="button"
            variant="bordered"
            width={"100%"}
            size="large"
            onClick={() => navigate("/educator")}
          >
            Cancel
          </Button>
        </form>
        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          onClose={() => setShowToast(false)}
        />
      </Layout>

      {classroomCreated &&
        navigate("/add-students/" + clssroomId)
      }

    </>
  );
}
